import { defineComponent, ref, computed } from "@vue/composition-api";
import { AssetList } from "@/components.assets/asset-list";
import { Asset } from "@/psychlab/types";
import { useTags } from "@/hooks/useTags";
import { AssetGrid } from "@/components.assets/asset-grid"
import { TagSidebar } from "@/components.tags/tag-sidebar";
import { ContextHeader } from "@/components.nav/context-header"
import { getInverseHexColor } from "./utils";
import * as Utils from "./utils";
import { AbsBox, SearchFilter, Container, Heading, TipIcon } from "@ui";
import { useTranslate } from "@lang";

export const AssetsHome = defineComponent({

	components: {
		AbsBox,
		AssetList,
		AssetGrid,
		TagSidebar,
		SearchFilter,
		Container,
		Heading,
		ContextHeader,
		TipIcon,
	},
	beforeRouteUpdate(to:any, from:any, next:any){ // note: hack until vue-router uses composition api
		const t = to.query["t"];
		if(this.currentTagId !== t){
			this.setCurrentTag(t);	
		}
		next();
	},
	setup(_, context){

		const searchFilter = ref(Utils.getQueryValue("filter", context, ""));

		const {
			translate
		} = useTranslate();

		const {
			sortedTags,
			tagItem,
		} = useTags();

		const currentTagId = ref<string|null>(null);

		const currentTag = computed(() => {
			return sortedTags.value.find(t => t._id === currentTagId.value);
		});

		const setCurrentTag = (v:string) => {
			currentTagId.value = v;
		};

		const init = async () => {
			const t = context.root.$route.query["t"];
			if(t && typeof(t) === "string"){
				currentTagId.value = t;
			}
		};

		const getAssetTagArgs = (asset:Asset) => {
			return {
				type:"asset",
				item:asset._id
			};
		};

		const tagDeleted = (tag:string) => {
			if(currentTagId.value === tag){
				currentTagId.value = null;
			}
		};

		const saveSearch = () => {
			const sv = searchFilter.value.length > 0 ? searchFilter.value : undefined;
			Utils.setQueryValue("filter", sv, context);
		};

		const clearSearch = () => {
			searchFilter.value = '';
			Utils.setQueryValue("filter", undefined, context);
		};

		init();

		return {
			currentTagId,
			currentTag,
			searchFilter,
			translate,
			setCurrentTag,
			getAssetTagArgs,
			tagItem,
			tagDeleted,
			getInverseColor:getInverseHexColor,
			clearSearch,
			saveSearch,
		};
	}

});